import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import ClergyDirectory from "@/components/ClergyDirectory";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

export default function Prelacies() {
  const [prelacies, setPrelacies] = useState([]);

  useEffect(() => {
    api.get("/prelacies").then((r) => setPrelacies(r.data)).catch(() => {});
  }, []);

  return (
    <section id="clero-e-prelazias" className="px-4 sm:px-8 lg:px-16 py-20 lg:py-32">
      <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}>
        <motion.p variants={fadeUp} className="overline-label text-[#4A0E17]/60">Estrutura Eclesiástica</motion.p>
        <motion.h2 variants={fadeUp} className="font-display mt-4 text-4xl sm:text-5xl font-bold uppercase leading-tight text-[#1C1917]">
          Clero e Prelazias
        </motion.h2>
        <motion.p variants={fadeUp} className="font-liturgy mt-6 max-w-3xl text-xl italic leading-relaxed text-[#1C1917]/65">
          A DACB é uma única Diocese nacional, organizada territorialmente em Prelazias — circunscrições pastorais presididas por Bispos Prelados, em comunhão e colegialidade com o Arcebispo Primaz. Conheça os bispos, presbíteros e diáconos que servem à Sé Primacial e às Prelazias, com suas missões, comunidades e pontos missionários.
        </motion.p>

        <motion.div variants={fadeUp} data-testid="prelacies-directory-list" className="mt-12 border-t border-[#E5DEC9]">
          {prelacies.map((p, i) => (
            <Link
              key={p.id || p.nome}
              data-testid={`prelacy-row-${i}`}
              to={`/prelazias/${p.slug || p.id}`}
              className="group grid sm:grid-cols-12 gap-2 sm:gap-6 items-baseline py-6 border-b border-[#E5DEC9] hover:bg-[#F4EFE6] transition-colors px-2 sm:px-4"
            >
              <span className="sm:col-span-1 font-display text-sm text-[#C5A059]">0{i + 1}</span>
              <h3 className="sm:col-span-6 font-display text-xl sm:text-2xl font-bold text-[#1C1917] group-hover:text-[#4A0E17] transition-colors">{p.nome}</h3>
              <p className="sm:col-span-5 text-sm text-[#1C1917]/55 sm:text-right">
                {p.cidade ? `${p.cidade} • ` : ""}{p.estado}
              </p>
            </Link>
          ))}
        </motion.div>

        <ClergyDirectory />
      </motion.div>
    </section>
  );
}
